var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadsend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58501 10.9993L4.03134 6.01535C3.87276 4.58901 5.34126 3.54126 6.63834 4.15635L17.587 9.34285C18.9849 10.0047 18.9849 11.9938 17.587 12.6557L6.63834 17.8431C5.34126 18.4573 3.87276 17.4104 4.03134 15.9841L4.58501 10.9993ZM4.58501 10.9993H11.0017",
    stroke: "#399E79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsend);
export default __webpack_public_path__ + "static/media/Leadsend.b0c9abcf1ecb0e550757a5edf913a73a.svg";
export { ForwardRef as ReactComponent };